import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { MenuActionTypes } from "./action-types";
import { MenuMutationTypes } from './mutation-types';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [MenuActionTypes.ACTION_SET_CONTRATO](
    { commit }: AugmentedActionContext,
    contrato: number,
  ): void;

  [MenuActionTypes.ACTION_SET_CODIGOESCOLA](
    { commit }: AugmentedActionContext,
    codigoEscola: number,
  ): void;

  [MenuActionTypes.ACTION_SET_CODIGOGRUPOUSUARIO](
    { commit }: AugmentedActionContext,
    codigoGrupo: number,
  ): void;

  [MenuActionTypes.ACTION_SET_CODIGOPROFESSOR](
    { commit }: AugmentedActionContext,
    codigoProfessor: number,
  ): void;

  [MenuActionTypes.ACTION_SET_CODIGORESPONSAVEL](
    { commit }: AugmentedActionContext,
    codigoResponsavel: number,
  ): void;

  [MenuActionTypes.ACTION_SET_CODIGOALUNO](
    { commit }: AugmentedActionContext,
    codigoAluno: number,
  ): void;

  [MenuActionTypes.ACTION_SET_CODIGOUSUARIO](
    { commit }: AugmentedActionContext,
    codigoUsuario: number,
  ): void;

  [MenuActionTypes.ACTION_SET_ANO](
    { commit }: AugmentedActionContext,
    ano: number,
  ): void;

  [MenuActionTypes.ACTION_SET_SEMESTRE](
    { commit }: AugmentedActionContext,
    semestre: number,
  ): void;

  [MenuActionTypes.ACTION_SET_READONLY](
    { commit }: AugmentedActionContext,
    readOnly: number,
  ): void;

  [MenuActionTypes.ACTION_SET_CHAMADA_VIA_PROXY](
    { commit }: AugmentedActionContext,
    chamadaViaProxy: boolean,
  ): void;

   
}


export const actions: ActionTree<State, RootState> & Actions = {
  [MenuActionTypes.ACTION_SET_CONTRATO]({ commit }, contrato: number) {
    sessionStorage.setItem('codigoContrato', JSON.stringify(contrato));
    localStorage.setItem('codigoContrato', JSON.stringify(contrato));
    commit(MenuMutationTypes.SET_CONTRATO, contrato);
  },
  [MenuActionTypes.ACTION_SET_CODIGOESCOLA]({ commit }, codigoEscola: number) {
    sessionStorage.setItem('codigoEscola', codigoEscola.toString());
    localStorage.setItem('codigoEscola', codigoEscola.toString());
    commit(MenuMutationTypes.SET_CODIGOESCOLA, codigoEscola);
  },
  [MenuActionTypes.ACTION_SET_CODIGOGRUPOUSUARIO]({ commit }, codigoGrupo: number) {
    sessionStorage.setItem('codigoGrupo', codigoGrupo.toString());
    localStorage.setItem('codigoGrupo', codigoGrupo.toString());
    commit(MenuMutationTypes.SET_CODIGOGRUPOUSUARIO, codigoGrupo);
  },
  [MenuActionTypes.ACTION_SET_CODIGOPROFESSOR]({ commit }, codigoProfessor: number) {
    sessionStorage.setItem('codigoProfessor', codigoProfessor.toString());
    localStorage.setItem('codigoProfessor', codigoProfessor.toString());
    commit(MenuMutationTypes.SET_CODIGOPROFESSOR, codigoProfessor);
  },
  [MenuActionTypes.ACTION_SET_CODIGORESPONSAVEL]({ commit }, codigoResponsavel: number) {
    sessionStorage.setItem('codigoResponsavel', codigoResponsavel.toString());
    localStorage.setItem('codigoResponsavel', codigoResponsavel.toString());
    commit(MenuMutationTypes.SET_CODIGORESPONSAVEL, codigoResponsavel);
  },
  [MenuActionTypes.ACTION_SET_CODIGOALUNO]({ commit }, codigoAluno: number) {
    sessionStorage.setItem('codigoAluno', codigoAluno.toString());
    localStorage.setItem('codigoAluno', codigoAluno.toString());
    commit(MenuMutationTypes.SET_CODIGOALUNO, codigoAluno);
  },
  [MenuActionTypes.ACTION_SET_CODIGOUSUARIO]({ commit }, codigoUsuario: number) {
    sessionStorage.setItem('codigoUsuario', codigoUsuario.toString());
    localStorage.setItem('codigoUsuario', codigoUsuario.toString());
    commit(MenuMutationTypes.SET_CODIGOUSUARIO, codigoUsuario);
  },
  [MenuActionTypes.ACTION_SET_ANO]({ commit }, ano: number) {
    sessionStorage.setItem('ano', ano.toString());
    localStorage.setItem('ano', ano.toString());
    commit(MenuMutationTypes.SET_ANO, ano);
  },
  [MenuActionTypes.ACTION_SET_SEMESTRE]({ commit }, semestre: number) {
    sessionStorage.setItem('semestre', semestre.toString());
    localStorage.setItem('semestre', semestre.toString());
    commit(MenuMutationTypes.SET_SEMESTRE, semestre);
  },
  [MenuActionTypes.ACTION_SET_READONLY]({ commit }, readOnly: number) {
    sessionStorage.setItem('readOnly', readOnly.toString());
    localStorage.setItem('readOnly', readOnly.toString());
    commit(MenuMutationTypes.SET_READONLY, readOnly);
  },
  [MenuActionTypes.ACTION_SET_CHAMADA_VIA_PROXY]({ commit }, chamadaViaProxy: boolean) {
    sessionStorage.setItem('chamadaViaProxy', chamadaViaProxy === true ? "1" : "0");
    localStorage.setItem('chamadaViaProxy', chamadaViaProxy === true ? "1" : "0");
    commit(MenuMutationTypes.SET_CHAMADA_VIA_PROXY, chamadaViaProxy);
  },
};
